// extracted by mini-css-extract-plugin
module.exports =  {"link-button":"_93444fe79c--link-button--ujZuh"};